import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import VerifiedIcon from '@mui/icons-material/Verified';
import StarIcon from '@mui/icons-material/Star';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  backgroundColor: theme.palette.background.paper,
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: theme.shadows[10],
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 80,
  height: 80,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.common.white,
  marginBottom: theme.spacing(2),
}));

const ProvenTrackRecord = () => {
  const features = [
    {
      icon: <VerifiedIcon fontSize="large" />,
      title: 'Flawless Execution',
      description:
        'Every event we produce is backed by meticulous planning and a zero‑compromise approach to quality.',
    },
    {
      icon: <StarIcon fontSize="large" />,
      title: 'Proven Excellence',
      description:
        'Our portfolio speaks for itself – a legacy of successful events that exceed expectations every time.',
    },
    {
      icon: <EmojiEventsIcon fontSize="large" />,
      title: 'Reliability',
      description:
        'Clients trust us to deliver perfection under pressure, time and again.',
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          gutterBottom
          sx={{ mb: 2, color: 'primary.dark' }}
        >
          Proven Track Record
        </Typography>
        <Typography
          variant="h5"
          align="center"
          color="text.secondary"
          sx={{ mb: 6, maxWidth: 800, mx: 'auto' }}
        >
          We have a history of flawlessly executed events, backed by a proven
          track record that reflects our dedication to excellence and
          reliability. One8 Event consistently raises the bar, ensuring each
          event is more remarkable than the last.
        </Typography>
        <Grid container spacing={4}>
          {features.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <StyledPaper elevation={3}>
                <IconWrapper>{item.icon}</IconWrapper>
                <Typography variant="h5" component="h3" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {item.description}
                </Typography>
              </StyledPaper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ProvenTrackRecord;